export default "__VITE_ASSET__71b0a661__"